import React  from 'react';
import ReactDOM from 'react-dom';


function GammeItem({item, selectGamme}) {

    return (<button className={item.isActive ? 'gamme-item active' : 'gamme-item'}  onClick={(e) => {
        e.preventDefault();
        selectGamme(item)
    }} type="submit">
        {item.title}
    </button>);
}

export default GammeItem;
